<template>
  <div class="warp">
    <div class="warpmain"></div>
    <div class="headwarp">

      <div class="head">
        <div class="logo"> <img src="../assets/images/logo.png" /></div>
        <span class="logintext">认养一头牛SRM供应商管理平台&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
      </div>
    </div>
    <div class="main">
      <div class="right">
        <div class="loginwarp">
          <div class="loginhead">用户登录</div>
          <!-- 登录表单区域 -->
          <!-- ref 创建了一个loginForm实例对象 -->
          <div class="loginbody">
            <el-form :model="loginForm" :rules="rules" ref="loginFormref">
              <!-- 登录账号 -->
              <div class="itemmd">
                <el-form-item prop="username">
                  <el-input placeholder="请输入账号" prefix-icon="iconfont icon-yonghuming" v-model="loginForm.username" autocomplete="on"></el-input>
                </el-form-item>
              </div>
              <!-- 登录密码-->
              <div class="itemmd">
                <el-form-item prop="password">
                  <el-input placeholder="请输入密码" prefix-icon="iconfont icon-iconfontcolor10-copy" v-model="loginForm.password" :type="pwdType" @keyup.enter.native="login(loginForm)">
                    <span slot="suffix" class="iconfont" :class="icon" @click="showPwd()" style="margin-right: 5px"></span>
                  </el-input>
                </el-form-item>
              </div>

              <div class="itemmdbtn">

                <el-button type="success" size="large" @click="login(loginForm)">登录</el-button>
              </div>
              <!-- 重置 -->
              <!-- <el-form-item>
            <el-button type="primary" size="large" @click="resetloginForm">重置</el-button>
          </el-form-item>-->
              <div class="itemmd">

                <router-link :to="{path:'/dlxxregister', params: {id:1}}" class="pull-right" style="margin-right:15px">忘记密码</router-link>
                <router-link :to="{path:'/dlxxregister', params: {id:1}}" class="pull-right" style="margin-right:15px">注册</router-link>
              </div>

            </el-form>
          </div>

        </div>
      </div>
    </div>

    <div class="is-with-footer el-dialog--center foot">
      <P>
        Copyright © 2012-2021 山东亿盖普信息科技有限公司
      </P>

    </div>

    <Imgtd v-if="visible" :visib="visible" @isshow="vishow" />

  </div>
</template>
<script>
import Imgtd from "../components/vail/Imgtd";

export default {
  components: {
    Imgtd,
  },
  data() {
    return {
      pwdType: "password",
      icon: "icon-pwd-hide",
      //登陆表单绑定对象
      loginForm: {
        username: "",
        password: "",
      },
      checked: true,
      visible: false,
      viscont: 0,
      //表单的验证规则对象
      rules: {
        //失去焦点时候验证用户名
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        //失去焦点时候验证密码
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },

      listVideoQuery: { orgLogo: "" },
      upPicName: "", //上传图片名字
      fileList1: [],
      form: {}, //上传到七牛的token
      bucketQuery: {
        bucket: "website-image", //这是我用来获取token传给后台的字段
      },
      domain: "http://upload.qiniu.com", // 七牛云的上传地址
      qiniuaddr: "pd6rnk9ck.bkt.clouddn.com", // 这是七牛云空间的外链默认域名
    };
  },
  mounted() {
    this.getCookie();
    if (localStorage.username) {
      this.loginForm = {
        username: localStorage.username,
        password: localStorage.password,
      };
    }
  },
  methods: {
    vishow(val) {
      this.visible = val;
    },
    //密码的隐藏和显示
    showPwd() {
      //三目运算
      this.pwdType = this.pwdType === "password" ? "text" : "password";
      this.icon =
        this.icon === "icon-xianshi" ? "icon-pwd-hide" : "icon-xianshi";
    },
    //点击重置按钮，表单重置
    resetloginForm() {
      this.$refs.loginFormref.resetFields();
    },
    login: _.debounce(function (formName) {
      this.logind(formName);
    }, 500),
    // login(formName):_.debounce(function () { {
    //     // this._.debounce(,1000,false)
    //     },1000,false),

    // //登录预验证
    logind(formName) {
      //与后端请求代码，本功能不需要与后台交互所以省略
      this.$refs.loginFormref.validate(async (valid) => {
        if (!valid) return;
        //  this.$qs.stringify(dataForm)
        const data = {
          username: formName.username,
          password: formName.password,
        };
        // alert(this.$qs.stringify(data));
        if (formName.username != "admin" || formName.password != "123456") {
          this.viscont += 1;
          if (this.viscont >= 3) {
            this.visible = true;
            this.viscont = 3;
          }
          localStorage.clear();
          this.$message.error("用户名或密码错误");
          return;
        } else if (
          formName.username == "admin" &&
          formName.password == "123456"
        ) {
          //判断复选框是否被勾选 勾选则调用配置cookie方法
          if (this.checked == true) {
            //传入账号名，密码，和保存天数3个参数
            this.setCookie(
              this.loginForm.username,
              this.loginForm.password,
              this.checked,
              70
            );
          } else {
            //清空Cookie
            this.clearCookie();
          }
          this.$message({ duration: 1000 });
          this.$message.success("登录成功");
          this.visid = 0;
          //1.将登录成功之后的token,保存到客户端的sessionStorage中
          //项目中的其他接口，必须登录之后才能访问
          //token只应在当前网站打开期间生效，所以将token保存在sessionStorage中
          // window.localStorage.setItem("token", res.result);
          window.localStorage.setItem("username", this.loginForm.username);
          window.localStorage.setItem("password", this.loginForm.password);
          // window.localStorage.setItem('token', res.data.token)
          //通过编程式导航跳转到后台主页，路由地址是/home
          // this.$store.state.openTab = [];
          // this.$store.state.activeIndex = "/home";
          this.$router.push("/home");
          // this.$router.replace({ name: 'home' })
        }
        // const { data: res } = await this.$axios.post("login", data);
        // console.log(res);
        // if (res.code !== 200) {
        //   // if (res.meta.status !== 200) {
        //   this.viscont += 1;
        //   if (this.viscont >= 3) {
        //     this.visible = true;
        //     this.viscont = 3;
        //   }
        //   localStorage.clear();
        //   return;
        // } else if (res.code == 200) {
        //   //判断复选框是否被勾选 勾选则调用配置cookie方法
        //   if (this.checked == true) {
        //     //传入账号名，密码，和保存天数3个参数
        //     this.setCookie(
        //       this.loginForm.username,
        //       this.loginForm.password,
        //       this.checked,
        //       7
        //     );
        //   } else {
        //     //清空Cookie
        //     this.clearCookie();
        //   }
        //   this.$message({ duration: 1000 });
        //   this.$message.success("登录成功");
        //   this.visid = 0;
        //   //1.将登录成功之后的token,保存到客户端的sessionStorage中
        //   //项目中的其他接口，必须登录之后才能访问
        //   //token只应在当前网站打开期间生效，所以将token保存在sessionStorage中
        //   window.localStorage.setItem("token", res.result);
        //   window.localStorage.setItem("username", this.loginForm.username);
        //   // window.localStorage.setItem('token', res.data.token)
        //   //通过编程式导航跳转到后台主页，路由地址是/home
        //   this.$store.state.openTab = [];
        //   this.$store.state.activeIndex = "/actSetup/loginlog";
        //   this.$router.push("/actSetup/loginlog");
        // }
      });
    },
    //设置cookie的值
    setCookie(c_name, c_pwd, c_check, exdays) {
      var exdate = new Date();
      exdate.setTime(exdate.getTime() + 24 * 60 * 60 * 1000 * exdays); //保存的天数
      document.cookie =
        "userName=" + c_name + ";path=/;expires=" + exdate.toLocaleString();
      document.cookie =
        "userPwd=" + c_pwd + ";path=/;expires=" + exdate.toLocaleString();
      document.cookie =
        "checkof=" + c_check + ";path=/;expires=" + exdate.toLocaleString();
    },
    //获取cookie的值
    getCookie: function () {
      if (document.cookie.length > 0) {
        var arr = document.cookie.split("; "); //这里显示的格式需要切割一下自己可输出看下
        // console.log(arr)
        for (var i = 0; i < arr.length; i++) {
          var arr2 = arr[i].split("="); //再次切割
          //判断查找相对应的值
          if (arr2[0] == "userName") {
            this.loginForm.username = arr2[1]; //保存到保存数据的地方
          } else if (arr2[0] == "userPwd") {
            this.loginForm.password = arr2[1];
          } else if (arr2[0] == "checkof") {
            this.checked = arr2[1];
            if (arr2[1] != "") {
              this.checked = eval(arr2[1].toLowerCase());
            }
          }
        }
      }
    },
    //删除cookie
    clearCookie: function () {
      this.setCookie("", "", "", -1); //修改2值都为空，天数为负1天就好了
    },
    // 上传图片规格
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg" || file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 5;
      if (!isJPG) {
        return this.$message.error("上传文件只能是 JPG或PNG 格式!");
      }
      if (!isLt2M) {
        return this.$message.error("上传图片大小不能超过 5MB!");
      }
      return upQiniu(this.bucketQuery).then((res) => {
        this.form = {
          token: res.data,
        };
      });
    },
    //图片改变及上传
    bannerPicChange(value) {
      this.fileList1 = [];
      this.fileList1.push({
        name: value,
        url: value,
      });
    },
    handleBannerPicRemove(file, fileList) {
      this.fileList1 = [];
      this.listVideoQuery.orgLogo = "";
    },
    handleAvatarSuccess(response) {
      if (this.upPicName == "orgLogo") {
        this.fileList1 = [];
        this.fileList1.push({
          name: "http://" + this.qiniuaddr + "/" + response.key,
          url: "http://" + this.qiniuaddr + "/" + response.key,
        });
        this.listVideoQuery.orgLogo =
          "http://" + this.qiniuaddr + "/" + response.key;
      }
      this.$message({
        type: "success",
        message: "上传成功!",
        duration: 2000,
      });
    },
    orgLogoChange() {},
  },
};
</script>
<style scoped>
@import url(../assets/css/login.css);
</style>